<script lang="ts" setup>
import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import { modalVariant, type ModalVariant } from '@exchange/libs/modals/src';

const props = defineProps({
  /** Title lokalise key */
  titleKey: { type: String, required: false },
  /** Message lokalise key */
  messageKey: { type: String, required: false },
  /** Message to show */
  message: { type: String, required: false },
  /** Can close modal */
  canClose: { type: Boolean, default: true },
  /** Close button lokalise key */
  closeButtonKey: { type: String, required: false },
  variant: { type: String as PropType<ModalVariant>, default: modalVariant.dark },
});

const emit = defineEmits<(e: 'x-error-close') => void>();

const { t } = useI18n({ useScope: 'global' });

const getText = (defaultKey: string, key?: string) => {
  if (key) {
    return t(key);
  }

  return t(defaultKey);
};

const errorMessage = computed(() => props.message || getText('modules.errors.errorModal.defaultMessage', props.messageKey));

const title = computed(() => getText('modules.errors.errorModal.title', props.titleKey));

const closeButtonText = computed(() => getText('modules.errors.errorModal.button', props.closeButtonKey));
</script>

<template>
  <x-modal
    :can-close="canClose"
    :title="title"
    :variant="variant"
    class="error-modal"
    type="base"
  >
    <template #content>
      <p>{{ errorMessage }}</p>
    </template>
    <template #buttons>
      <x-button
        ref="ok"
        variant="primary"
        :text="closeButtonText"
        @click="emit('x-error-close')"
      />
    </template>
  </x-modal>
</template>
